const snakeObject = obj => {
    if (isFormData(obj)) {
        const fd = new FormData()
        for (let pair of obj.entries()) {
            fd.append(pair[0] === '_method' ? pair[0] : _.snakeCase(pair[0]), pair[1])
        }
        return fd
    } else if (isArray(obj)) {
        return obj.map(snakeObject)
    } else if (isObject(obj)) {
        const result = {}
        Object.keys(obj).map(
            k => (result[k === '_method' ? k : _.snakeCase(k)] = snakeObject(obj[k]))
        )
        return result
    } else {
        return obj
    }
}

const isObject = o => {
    return o === Object(o) && !isArray(o) && typeof o !== 'function'
}

const isArray = o => {
    return Array.isArray(o)
}

const isFormData = o => o instanceof FormData

export default snakeObject
